
import React from 'react';

const ContactSection: React.FC = () => {
  return (
    <section className="py-20 bg-blue-50">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl font-bold mb-8 text-gray-800">
            不動産に関するご相談はお気軽に
          </h2>
          <p className="text-xl text-gray-700 mb-12 leading-relaxed">
            ご購入・ご売却・お住まいのリフォームなど、どんなことでもご相談ください。<br />
            地域に精通したスタッフが、お客様に最適なご提案をいたします。
          </p>
          <div className="flex flex-col sm:flex-row gap-6 justify-center">
            <button className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-colors duration-300 whitespace-nowrap cursor-pointer">
              <i className="ri-mail-line mr-2"></i>
              お問い合わせフォームへ
            </button>
            <button className="bg-white hover:bg-gray-50 text-blue-600 border-2 border-blue-600 px-8 py-4 rounded-lg text-lg font-semibold transition-colors duration-300 whitespace-nowrap cursor-pointer">
              <i className="ri-calculator-line mr-2"></i>
              無料査定はこちら
            </button>
          </div>
          <div className="mt-12 p-6 bg-white rounded-lg shadow-md">
            <div className="grid md:grid-cols-3 gap-6 text-center">
              <div>
                <i className="ri-phone-line text-3xl text-blue-600 mb-2"></i>
                <h3 className="font-semibold text-gray-800 mb-2">お電話でのお問い合わせ</h3>
                <p className="text-2xl font-bold text-blue-600">03-1234-5678</p>
                <p className="text-sm text-gray-600">平日 9:00-18:00</p>
              </div>
              <div>
                <i className="ri-mail-line text-3xl text-blue-600 mb-2"></i>
                <h3 className="font-semibold text-gray-800 mb-2">メールでのお問い合わせ</h3>
                <p className="text-blue-600">info@pm-realestate.co.jp</p>
                <p className="text-sm text-gray-600">24時間受付</p>
              </div>
              <div>
                <i className="ri-time-line text-3xl text-blue-600 mb-2"></i>
                <h3 className="font-semibold text-gray-800 mb-2">営業時間</h3>
                <p className="text-gray-700">平日 9:00-18:00</p>
                <p className="text-sm text-gray-600">土日祝日も対応可</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
